import { render } from "./ugc-creator-form.vue?vue&type=template&id=014205e2"
import script from "./ugc-creator-form.vue?vue&type=script&lang=js"
export * from "./ugc-creator-form.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ab-front-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__